import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
// import { base_URL } from "../../../../utils/api";
import axiosInstance from "../../../../axiosinterceptor";
// const initialPageSize = JSON.parse(localStorage.getItem("enableHCPQueryParamsFunctionality") || "false")
//   ? 100
//   : 20;


const initialState = {
  selectedEpisode: {},
  viewEpisodesFiltersList: {
    episodesFilterList: [],
    episodesFilterListLoading: false,
    episodesFilterListError: null,
  },
  episodeListFilterObj: {
    medical_record_number: "",
    // hospital_identifier: "",
    episode_identifier: "",
    admission_date: "",
    separation_date: "",
    length_of_stay: null,
    speciality: [],
    drg: [],
    status: [],
    sort_by: "asc",
    sort_order: "",
    page_size: 20,
    // page_size: initialPageSize,
    page: 1,
    document_name: []
    // priority: "",
    // Provisional_NWAU: "",
    // documentTypes: "",
    // aIProcessingStatus: ""
  },
  getFilterOptions: {
    filterOptions: [],
    filterOptionsLoading: false,
    filterOptionsError: null,
  },
};


export const getFilterEpisodeLists = createAsyncThunk(
  '/getFilterEpisodeLists',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    const episodesPayload = {
      body: payload
    }
    const header = {
      content_type: "application.json"
    }
    try{
      const response = await axiosInstance.post("/Filter_navigation_acs", payload);
      // const data = JSON.parse(response.data.body);
      const data = response.data;
      // console.log(data, 'data1')
      return fulfillWithValue(data)
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

// export const getFilterEpisodeLists = createAsyncThunk(
//   '/getFilterEpisodeLists',
//   async (payload, { fulfillWithValue, rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.post("/Filter_navigation_acs", payload);
//       const data = response.data;
//       const modifiedEpisodes = data?.episode?.map((item, index) => ({
//   ...item,
//   type_patient:  index % 2 !== 0 ? "outPatient" : "inPatient"
// }));

// const modifiedData = {
//   ...data,
//   episode: modifiedEpisodes,
// };

//       console.log("API original data:", data);
//       console.log("Modified final data:", modifiedData);

//       return fulfillWithValue(modifiedData);

//     } catch (error) {
//       console.error('Error fetching episodes:', error);
//       return rejectWithValue(error.response?.data?.message || error.message || "No data found");
//     }
//   }
// );


export const getEpisodeFilterOptions = createAsyncThunk(
  '/getEpisodeFilterOptions',
  async(_, { fulfillWithValue, rejectWithValue }) => {
    try{
      const response = await axiosInstance.get(`/fields_acs`);
      const data = response?.data;
      // console.log(response, 'data1')
      return fulfillWithValue(data)
      // return data; 
    }
    catch(error) {
      console.error('Error fetching filter episodes options:', error);
      return rejectWithValue(error.response?.data?.message || error.message ||  "No data found");
      // throw error;
    }
  }
)

const episodeListSlicer = createSlice({
  name: "episodeList",
  initialState,
  reducers: {
    selectedEpisodeList: (state, action) => {
      state.selectedEpisode = action.payload;
    },
    setEpisodeListFilterObj: (state, action) => {
      state.episodeListFilterObj = action.payload;
    },
  },
  extraReducers: (builder) => builder.addCase(getFilterEpisodeLists.pending, (state) => {
    state.viewEpisodesFiltersList.episodesFilterListLoading = true;
    state.viewEpisodesFiltersList.episodesFilterListError = null;
  }).addCase(getFilterEpisodeLists.fulfilled, (state,action) => {
    state.viewEpisodesFiltersList.episodesFilterListLoading= false;
    state.viewEpisodesFiltersList.episodesFilterList = action.payload;
  }).addCase(getFilterEpisodeLists.rejected, (state, action) => {
    state.viewEpisodesFiltersList.episodesFilterListLoading = false;
    state.viewEpisodesFiltersList.episodesFilterListError = action.payload;
  })
  .addCase(getEpisodeFilterOptions.pending, (state) => {
    state.getFilterOptions.filterOptionsLoading = true;
    state.getFilterOptions.filterOptionsError = null;
  }).addCase(getEpisodeFilterOptions.fulfilled, (state, action) => {
    state.getFilterOptions.filterOptionsLoading= false;
    state.getFilterOptions.filterOptions = action.payload;
  }).addCase(getEpisodeFilterOptions.rejected, (state, action) => {
    state.getFilterOptions.filterOptionsLoading = false;
    state.getFilterOptions.filterOptionsError = action.payload;
  })
});

export const { selectedEpisodeList, setEpisodeListFilterObj } = episodeListSlicer.actions;

export default episodeListSlicer.reducer;
